// removed by extract-text-webpack-plugin
module.exports = {"absolute-center":"onfido-sdk-ui-CameraPermissions-Primer-absolute-center","text":"onfido-sdk-ui-CameraPermissions-Primer-text","image":"onfido-sdk-ui-CameraPermissions-Primer-image","reasons":"onfido-sdk-ui-CameraPermissions-Primer-reasons","reason":"onfido-sdk-ui-CameraPermissions-Primer-reason","graphic":"onfido-sdk-ui-CameraPermissions-Primer-graphic","allow":"onfido-sdk-ui-CameraPermissions-Primer-allow"};


//////////////////
// WEBPACK FOOTER
// ./components/CameraPermissions/Primer/style.css
// module id = 369
// module chunks = 1